module.exports = __webpack_public_path__ + "static/media/auditor2.d66ed6a2.png";